<template>
  <app-dialer-common-page
    class="app-dialer-call-members-page"
    :title="title"
    :is-loading="isLoading"
    :is-disabled="isDisabled"
    @go-back="$emit('go-back', $event)"
  >
    <base-item
      v-for="member of members"
      :key="member.memberId"
      :avatar="avatar"
      :person="getPerson(member)"
      :title="getMemberName(member)"
      :description="getMemberIdentifierLabel(member)"
      :status="getMemberStatusLabel(member)"
      :status-type="getMemberStatusType(member)"
      :actions="getMemberOptions(member)"
      :is-disabled="isDisabled"
      size="mobile"
      actions-type="popup"
      @action-click="onActionClick($event, member)"
    />
  </app-dialer-common-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { TranslateResult } from 'vue-i18n';

import { AppDialerCommonPage } from '../common';
import { BaseItem } from '@/modules/agent-picker';
import { useDialerMembers } from '../../composables';
import { AVATAR_PROP, MEMBERS_PROP } from '../../constants';

export default defineComponent({
  name: 'AppDialerCallMembersPage',
  components: {
    AppDialerCommonPage,
    BaseItem,
  },
  props: {
    avatar: AVATAR_PROP,
    members: MEMBERS_PROP,
    isLoading: Boolean,
    isDisabled: Boolean,
  },
  emit: ['hang-up', 'go-back'],
  setup() {
    const {
      getPerson,
      getMemberName,
      getMemberIdentifierLabel,
      getMemberStatusLabel,
      getMemberStatusType,
      getMemberOptions,
      onActionClick,
    } = useDialerMembers();

    return {
      getPerson,
      getMemberName,
      getMemberIdentifierLabel,
      getMemberStatusLabel,
      getMemberStatusType,
      getMemberOptions,
      onActionClick,
    };
  },
  computed: {
    title(): TranslateResult {
      if (this.isLoading) {
        return this.$t('hitl.common.loadingWithDots');
      }

      const data = { count: this.members.length };
      return this.$t('hitl.modules.dialer.call-members-title', data);
    },
  },
});
</script>
